import React from 'react';

class BillingDetails extends React.Component {
    constructor(props) {
        super(props);
        this.containerRef = React.createRef();
    }

    focusFirstInvalid = () => {
        if (this.props.collapsed && this.props.onToggleCollapse) {
            this.props.onToggleCollapse();
        }
        setTimeout(() => {
            const container = this.containerRef.current;
            if (container) {
                const invalid = container.querySelector(':invalid');
                if (invalid) invalid.focus();
            }
        }, 100);
    };

    render() {
        const {
            billing_address,
            billing_contact_no,
            onChange,
            collapsed,
            onToggleCollapse,
        } = this.props;

        return (
            <div
                className="billing_details_container blocks"
                ref={this.containerRef}
            >
                <div className="subtitle collapsible-header" onClick={onToggleCollapse}>
                    Billing
                    <span className="toggle-icon">{collapsed ? '+' : '-'}</span>
                </div>

                <div className={`collapsible-body ${collapsed ? 'collapsed' : ''}`}>
                    <div className="input_label">Address</div>
                    <textarea
                        className="input billing_address custom_input"
                        name="billing_address"
                        value={billing_address}
                        onChange={onChange}
                        autoComplete="off"
                    />

                    <div className="input_label">Contact No</div>
                    <input
                        className="billing_contact_no input custom_input"
                        type="tel"
                        name="billing_contact_no"
                        value={billing_contact_no}
                        onChange={onChange}
                        autoComplete="off"
                    />
                </div>
            </div>
        );
    }
}

export default BillingDetails;
